"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAVIGATOR_LANGUAGE_REGEX = exports.hasWindow = exports.getStandardLanguage = void 0;
var constants_1 = require("./constants");
/**
 * ### 从后向前匹配语言码，直至第一位语言码，如果仍然无法匹配，返回默认语言英文 Language.en_US
 *
 * @param language 全小写，被 - 和 _ 分割后的字符串数组
 * @returns 语言枚举值
 */
function mapLanguage(language) {
    while (language.length > 0) {
        var key = language.join('_');
        if (constants_1.LANGUAGE_DICTIONARY.hasOwnProperty(key)) {
            return constants_1.LANGUAGE_DICTIONARY[key];
        }
        language.pop();
    }
    return constants_1.Language.en_US;
}
/**
 * ### 基于语言码字符串，获得语言枚举值。对于多种不同规则的语言码，给出统一的枚举值
 *
 * 比如： zh-CN, zh-Hans, zh_cn 都会返回 Language.zh_CN
 *
 * 对于不支持的语言码，会返回默认语言英文 Language.en_US
 * ```typescript
 * const lang = "zh-Hans";
 * getStandardLanguage(lang); // return Language.zh_CN
 * ```
 *
 * @param languageCode - 语言码字符串
 * @returns 语言枚举值
 *
 */
function getStandardLanguage(languageCode) {
    var splitter = /[-_]/g;
    var language = languageCode.toLowerCase().split(splitter);
    return mapLanguage(language);
}
exports.getStandardLanguage = getStandardLanguage;
/**
 * 判断是否有全局 window
 *
 * 大量语言判断是依赖于全局 window，因此此函数可用来判断是否可以使用 window
 */
function hasWindow() {
    return typeof (window) !== 'undefined';
}
exports.hasWindow = hasWindow;
// language/zh-cn
// TaurusLanguage/zh_CN
exports.NAVIGATOR_LANGUAGE_REGEX = /language\/(\S+)/i;
//# sourceMappingURL=utilities.js.map